/* Copyright (c) 2017 Backpack Health LLC */

import { apiRequest, authorizedApiRequest } from './ApiRequest';

import ApiErrorModel from '../models/ApiErrorModel';

const ContactService = {

  allProviders() {
    return authorizedApiRequest('get', '/users/contacts?type=provider')
      .then(res => res.body.data);
  },

  allContacts() {
    return authorizedApiRequest('get', '/users/contacts')
      .then(res => res.body.data);
  },

  allProvidersForProfile(profileId) {
    return authorizedApiRequest('get', `/profiles/${profileId}/contacts?type=provider`)
      .then(res => res.body.data);
  },

  allContactsForProfile(profileId) {
    return authorizedApiRequest('get', `/profiles/${profileId}/contacts`)
      .then(res => res.body.data);
  },

  getContact(profileId, contactId) {
    return authorizedApiRequest('get', `/profiles/${profileId}/contacts/${contactId}`)
      .then(res => res.body.data);
  },

  createContact(data) {
    const profileId = data.profile_id;
    return authorizedApiRequest('post', `/profiles/${profileId}/contacts`)
      .send(data)
      .then(res => res.body.data)
      .catch((err) => {
        throw new ApiErrorModel(err);
      });
  },

  updateContact(data) {
    const profileId = data.profile_id;
    const contactId = data.id;
    return authorizedApiRequest('put', `/profiles/${profileId}/contacts/${contactId}`)
      .send(data)
      .catch((err) => {
        throw new ApiErrorModel(err);
      });
  },

  deleteContact(profileId, contactId) {
    return authorizedApiRequest('delete', `/profiles/${profileId}/contacts/${contactId}`);
  },

};

export default ContactService;
